import{a as t}from"./chunk-JAZTRPUN.js";import{m as n}from"./chunk-HBP5N4FR.js";n();import{TransactionPayload as a}from"@multiversx/sdk-core/out";var f=o=>{let r=o!=null?o:"";return t(r)?a.fromEncoded(r):new a(r)};export{f as a};
//# sourceMappingURL=chunk-UYEK2HPA.js.map
